<section>
    <link-button primary rounded><a href="#footer-signup">start today</a></link-button>
    <h2>Join MVP CTO</h2>
    <p>One base Subscription to plan and build your MVP. Add Additional services as needed.</p>
    <cta-button><a href="#pricing">See plan pricing</a></cta-button>
</section>